import { CategoryResponse } from "@/main/models/response";

export enum CategoryTypes {
	GET_CATEGORY = "@category/GET_CATEGORY",
	SAVE_CATEGORY = "@category/SAVE_CATEGORY",
	RESET_REDUCER_CATEGORY = "@category/RESET_REDUCER_CATEGORY",
}

export interface CategoryState {
	readonly category: {
		data: CategoryResponse[] | null;
		errorMessages: string[] | null;
		isError: boolean;
		isLoading: boolean;
	};
}

export interface GetCategory {
	type: typeof CategoryTypes.GET_CATEGORY;
	payload: {
		isCanastaBasica: boolean;
	};
}

export interface SaveCategory {
	type: typeof CategoryTypes.SAVE_CATEGORY;
	payload: {
		data: CategoryResponse[] | null;
		isError: boolean;
		errorMessages: string[] | null;
	};
}

export interface ResetReducerCategory {
	type: typeof CategoryTypes.RESET_REDUCER_CATEGORY;
}

export type CategoryActionTypes = GetCategory | SaveCategory | ResetReducerCategory;
